import { z } from "zod";
import { CollectionOrigin } from "../collection";

export const CollectionImportModelInput = z.object({
  id: z.string(),
  name: z.string(),
});

export const CollectionImportModel = z.object({
  id: z.string(),
  name: z.string(),
  origin: CollectionOrigin,
});

export type CollectionImportModelInput = z.infer<typeof CollectionImportModelInput>;
export type CollectionImportModel = z.infer<typeof CollectionImportModel>;
